const API_BASE = '';

export const apiFetch = (path, options) => fetch(API_BASE + path, options);
